<show-message [type]="messageType.INFO">
    <div info>
        @if (isPopupBlocked) {
            <p>{{ 'PARTY.CASHIER.web.deposit.popupblock.message' | translate }}</p>
            <b>
                <a href="javascript: void(0);" class="d-flex justify-content-end" (click)="redirectToThirdParty()">
                    {{ 'PARTY.CASHIER.web.continue' | translate }}
                </a>
            </b>
        } @else {
            <p>{{ 'PARTY.CASHIER.web.deposit.redirected.message' | translate }}</p>
        }
    </div>
</show-message>
